<template>
    <b-card no-body>
        <div class="card-header pb-0">
            <div class="col-md-12 pl-0">
                <b-card-title>
                    {{ $t('Page(OrganizationCard):Component(EchaSandBoxSettings):title') }}
                </b-card-title>
            </div>
        </div>
        <div class="p-2">
            <validation-observer ref="settings">
                <b-form-group
                    :label="$t('Page(OrganizationCard):Component(EchaSandBoxSettings):label-enabled')"
                    label-for="sandboxEnabled"
                >
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Page(OrganizationCard):Component(EchaSandBoxSettings):label-enabled')"
                        rules="required"
                    >
                        <b-form-checkbox
                            id="sandboxEnabled"
                            checked="true"
                            name="check-button"
                            class="mb-1"
                            @input="onChange"
                            switch
                            inline
                            v-model="enabled"
                        >
                            {{ $t('Page(OrganizationCard):Component(EchaSandBoxSettings):is-sandbox-enabled') }}
                        </b-form-checkbox>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <b-form-group
                    :label="$t('Page(OrganizationCard):Component(EchaSandBoxSettings):label-namespace')"
                    label-for="namespace"
                >
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Page(OrganizationCard):Component(EchaSandBoxSettings):label-namespace')"
                        rules="required"
                    >
                        <b-form-input
                            :state="errors.length > 0 ? false:null"
                            id="namespace"
                            @input="onChange"
                            v-model="namespace"
                            :placeholder="$t('Page(OrganizationCard):Component(EchaSandBoxSettings):placeholder-namespace')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </div>
    </b-card>
</template>

<script>
import {BCard, BCardTitle, BFormGroup, BFormInput, BFormCheckbox} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
export default {
    components: {
        BCard, BCardTitle, BFormGroup, BFormInput, ValidationProvider, ValidationObserver, BFormCheckbox
    },
    props: {
        settings: {
            default() {
                return {

                };
            }
        }
    },
    data() {
        return {
            enabled: false,
            namespace: ''
        };
    },
    methods: {
        onChange() {
            this.$emit('input', {
                enabled: this.enabled,
                namespace: this.namespace
            });
        }
    },
    watch: {
        settings(settings) {
            if (settings) {
                this.enabled = settings.enabled;
                this.namespace = settings.namespace;
            }
        }
    }
};
</script>
